// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__35SBG","alertIcon":"ConfirmModal_alertIcon__2pd-Y"};